import React from 'react';
import './App.scss';
import { Routes, BrowserRouter, Route } from 'react-router-dom';
import Login from './routes/login/Login';
import Dashboard from './routes/dashboard/Dashboard';
import PrivateRoute from './util/component/PrivateRoute';
import { Provider } from 'react-redux'
import { store } from './redux/store';

function App() {
    return (
        <Provider store={store}>
            <div className='App'>
                <BrowserRouter>
                    <Routes>
                        <Route path='/login' element={<Login />} />
                        <Route path='*' element={<PrivateRoute component={Dashboard} />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </Provider>
    );
}

export default App;
